module.exports = __webpack_public_path__ + "static/orbis-logo-ab3c8a6ff6d9bdc8f4523f49aa789be9.jpeg";